import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doPostFiles, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

//Background
export const getBackground = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/background`
  return doGet(url)
}

//Form 0
export const saveForm0 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0`
  return doPost(url, request)
}

export const updateForm0 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0/${request.id}`
  return doPut(url, request)
}

export const getForm0 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0`
  return doGet(url)
}

export const getFilesForm0 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0/attachments`
  return doGet(url)
}

export const editFileNameForm0 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0/attachments/${request.id}`
  return doPut(url, request)
}

export const uploadFilesForm0 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0/attachments`
  return doPostFiles(url, request)
}

export const deleteFilesForm0 = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/form0/attachments/${fileId}`
  return doDelete(url)
}

export const changeAttachmentBackgroundSeqNo = (projectVersionId, fileId, seqNo) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/background/attachments/${fileId}/${seqNo}`
  return doPut(url)
}

//Form 1
export const saveForm1 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form1`
  return doPost(url, request)
}

export const updateForm1 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form1/${request.id}`
  return doPut(url, request)
}

export const getForm1 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form1`
  return doGet(url)
}

//Form 2
export const saveForm2 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form2`
  return doPost(url, request)
}

export const updateForm2 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form2/${request.id}`
  return doPut(url, request)
}

export const getForm2 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form2`
  return doGet(url)
}

//Form 3
export const saveForm3 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form3`
  return doPost(url, request)
}

export const updateForm3 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form3/${request.id}`
  return doPut(url, request)
}

export const getForm3 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form3`
  return doGet(url)
}

//Form 4
export const saveForm4 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form4`
  return doPost(url, request)
}

export const updateForm4 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form4/${request.id}`
  return doPut(url, request)
}

export const getForm4 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form4`
  return doGet(url)
}

//Form 5
export const saveForm5 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form5`
  return doPost(url, request)
}

export const updateForm5 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form5/${request.id}`
  return doPut(url, request)
}

export const getForm5 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form5`
  return doGet(url)
}

//Form 6
export const saveForm6 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form6`
  return doPost(url, request)
}

export const updateForm6 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form6/${request.id}`
  return doPut(url, request)
}

export const getForm6 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form6`
  return doGet(url)
}

export const downloadFileForm6 = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/form6/attachments/${fileId}/download`
  return doDownload(url)
}

//Form 7
export const saveForm7 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form7`
  return doPost(url, request)
}

export const updateForm7 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form7/${request.id}`
  return doPut(url, request)
}

export const getForm7 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form7`
  return doGet(url)
}

//Form 8
export const saveForm8 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form8`
  return doPost(url, request)
}

export const updateForm8 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form8/${request.id}`
  return doPut(url, request)
}

export const getForm8 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form8`
  return doGet(url)
}

//Form 9
export const getForm9 = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9`
  return doGet(url)
}

export const saveForm9 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9`
  return doPost(url, request)
}

export const updateForm9 = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9/${request.id}`
  return doPut(url, request)
}

export const getForm9Attachments = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9/attachments`
  return doGet(url)
}

export const uploadForm9Attachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9/attachments`
  return doPostFiles(url, request)
}

export const updateForm9Attachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9/attachments/${request.id}`
  return doPut(url, request)
}

export const deleteForm9Attachments = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9/attachments/${fileId}`
  return doDelete(url)
}

export const downloadForm9Attachments = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/project/form9/attachments/${fileId}/download`
  return doDownload(url)
}
